import React, { useContext } from 'react';
import { ChevronLeft } from 'react-bootstrap-icons';

import AppContext from '../../../context';
import {
  KiteIcon,
  AngelBrokingIcon,
  UpstoxIcon,
  GrowwIcon,
  FivepaisaIcon,
  DhanIcon,
  MotilalIcon,
  TrustlineIcon,
} from '../../../../assets/icons';
import { onKiteSync, onBrokerSync } from '../../../../utils';
import './connect_to_broker.component.css';

const ConnectToBroker = (props) => {
  const context = useContext(AppContext);
  const { pfId, onBack, onSync, onExistingKitePortfolioSync } = props;
  const pf = context.portfoliosById[pfId];

  const fetchHoldings = async () => {
    onBrokerSync(pfId, onSync);
  };

  const fetchKiteHoldings = async () => {
    onKiteSync(pfId, onSync, onExistingKitePortfolioSync);
  };

  return (
    <>
      <section className="add-tx-content">
        <div className="add-tx-header position-relative px-md-5 pt-md-5 px-sm-4 pt-sm-4 px-4 pt-4">
          <span className="step-text">{pf.name}</span>
          <h5 className="step-heading pt-1">CONNECT TO BROKER</h5>
        </div>
        <div className="connect_to_broker">
          <h4>Connect to your Broker</h4>
          <p>Instantly pull your data</p>
          <p>All features except IRR and Sharpe ratio</p>
          <p>
            *For connecting multiple accounts of same broker to your portfolios,
            you can follow the{' '}
            <a href="/support" target="_blank">
              guide
            </a>
          </p>
          <div className="brokers">
            <div onClick={fetchKiteHoldings}>
              <img src={KiteIcon} alt="zerodha" />
              <div>Zerodha</div>
            </div>
            <div onClick={fetchHoldings}>
              <img src={AngelBrokingIcon} alt="angel one" />
              <div>Angel One</div>
            </div>
            <div onClick={fetchHoldings}>
              <img src={UpstoxIcon} alt="upstox" />
              <div>Upstox</div>
            </div>
            <div onClick={fetchHoldings}>
              <img src={GrowwIcon} alt="groww" />
              <div>Groww</div>
            </div>
            <div onClick={fetchHoldings}>
              <img src={FivepaisaIcon} alt="5paisa" />
              <div>5paisa</div>
            </div>
            <div onClick={fetchHoldings}>
              <img src={DhanIcon} alt="dhan" />
              <div>Dhan</div>
            </div>
            <div onClick={fetchHoldings}>
              <img src={MotilalIcon} alt="motilal oswal" />
              <div>Motilal Oswal</div>
            </div>
            <div onClick={fetchHoldings}>
              <img src={TrustlineIcon} alt="trustline" />
              <div>Trustline</div>
            </div>
          </div>
        </div>
      </section>
      <div className="modal-footer">
        <button
          type="button"
          className={`mr-auto back-button btn btn-sm ${
            props.emptyPfs ? 'invisible' : ''
          }`}
          onClick={props.emptyPfs ? undefined : onBack}
        >
          <ChevronLeft /> <span>Back</span>
        </button>
      </div>
    </>
  );
};

export default ConnectToBroker;
